import { Box, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { ReactElement, useState } from "react";

type TMessageProps = {
  message: string | ReactElement;
  boldWord: string | undefined;
  closable: boolean;
  bgColor: string;
  textColor: string;
  borderRadius: string;
  textAlign: string;
  fontSize: string;
  mb: number;
};

function Message(props: TMessageProps) {
  const [visible, setVisible] = useState(true);
  const {
    message,
    boldWord,
    closable,
    textColor,
    bgColor,
    borderRadius,
    textAlign,
    fontSize,
    mb,
  } = props;
  if (visible) {
    return (
      <Box
        sx={{
          backgroundColor: bgColor,
          color: textColor,
          padding: ".7rem",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: borderRadius,
          textAlign: textAlign,
          mb: mb,
          width: "100%",
        }}
      >
        <Typography
          variant="body1"
          sx={{ fontSize: fontSize, width: "100%" }}
          component="div"
        >
          <strong>{boldWord}</strong>{" "}
          {typeof message === "string" ? message : <span>{message}</span>}
        </Typography>
        {closable && (
          <IconButton onClick={() => setVisible(false)}>
            <Close />
          </IconButton>
        )}
      </Box>
    );
  } else {
    return null;
  }
}

export default Message;
